import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import TabsToolbar from 'Components/TabsToolbar';
import SiteVerification from 'Components/Verification/SiteVerification';
import React from 'react';
import { HEADER_HEIGHT, SPACER_MINI, TABS_HEIGHT } from 'utils/ui/constants';
import Details from './Details';
import Devices from './Devices';
import Indicators from './Indicators';
import Zones from './Zones';

const MainContainer = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.backgrounds.color.main,
    padding: '0px 10px 10px',
    height: `calc(100vh - ${HEADER_HEIGHT}px)`
}));

const HeaderContainer = styled(Grid)({
    height: `${TABS_HEIGHT + SPACER_MINI}px`,
    width: '100%'
});

const BottomContainer = styled(Grid)({
    height: `calc(100% - ${TABS_HEIGHT + SPACER_MINI}px)`,
    overflowY: 'auto'
});

const Component = ({ siteId, section = 'details' }) => {
    let Section;

    switch (section) {
        case 'indicators':
            Section = <Indicators siteId={siteId}/>;
            break;
        case 'devices':
            Section = <Devices siteId={siteId}/>;
            break;
        case 'zones':
            Section = <Zones siteId={siteId}/>;
            break;
        case 'verifications':
            Section = <SiteVerification siteId={siteId}/>;
            break;
        default:
            Section = <Details siteId={siteId}/>;
    }

    const tabs = [
        { id: 'details', text: 'Details', url: `/sites/${siteId}/details` },
        { id: 'devices', text: 'Devices', url: `/sites/${siteId}/devices` },
        { id: 'indicators', text: 'Indicators', url: `/sites/${siteId}/indicators` },
        { id: 'zones', text: 'Zones', url: `/sites/${siteId}/zones` },
        { id: 'verifications', text: 'Verifications', url: `/sites/${siteId}/verifications` }
    ];

    return (
        <MainContainer container>
            <HeaderContainer size={12}>
                <TabsToolbar currentTab={section} tabs={tabs}/>
            </HeaderContainer>
            <BottomContainer size={12}>
                {Section}
            </BottomContainer>
        </MainContainer>
    );
};

export default Component;
